_ = require 'underscore'
React = require 'react'
t = require('views/internal/recup-with-helpers')('org_members')

module.exports = class OrganizationActionsStatusComponent extends React.Component

  constructor: (props) ->
    super(props)

  render: t.renderable ->
    { statusMessages, onDismiss } = @props
    errorResponses = _.without(statusMessages._categories, statusMessages._categories.ADDED)

    t.div '.org-members-actions-status-error', ->
      t.div '.org-members-actions-status-error-close', ->
        t.icon 'close', { onClick: onDismiss }
      t.format 'add-member-error'

      for category in _.values(errorResponses) when statusMessages[category]?.length > 0
        t.p '.message', ->
          t.span '.error-message-text', ->
            t.format 'add-member-error-' + category
          t.text ' '
          t.text statusMessages[category].join(', ')




// WEBPACK FOOTER //
// ./app/scripts/views/organization/organization-actions-status-component.coffee